import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLoader } from "actions/Base";
import {
  callApi,
  getPrescriptionReportFile
} from "api/apiList";
import Table, { defaultOptions, defaultCol, dateColumn } from "components/Form/Table";

const PrescripctionsReport = ({ dateRange }) => {
  const dispatch = useDispatch();
  const fnSetLoader = (data) => dispatch(setLoader(data));
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    if (!dateRange) return;

    callApi(
      () => getPrescriptionReportFile(dateRange.startDate, dateRange.endDate, false),
      (data) => setReportData(data.dataTable),
      fnSetLoader
    );
  }, [dateRange]);

  const columns = [
    defaultCol("nurse", "role.callAgent"),
    defaultCol("city", "core.city"),
    defaultCol("insurance", "core.insurance"),
    defaultCol("patientDocument", "core.documentShort"),
    defaultCol("patient", "core.patient"),
    defaultCol("marketchain", "reports.marketChain"),
    defaultCol("prescriptionCode", "core.mipres"),
    dateColumn("expeditionDate", "core.expeditionDateShort"),
    dateColumn("expirationDate", "core.expirationDate"),
    defaultCol("causal", "core.causal"),
    defaultCol("state", "core.state"),
    defaultCol("numberDeliveries", "insuranceAuthorization.deliveryNumber"),
    defaultCol("medicineAmount", "core.totalAmount"),
    defaultCol("unitValue", "core.unitValue"),
    defaultCol("product", "core.product"),
    defaultCol("deliveriesMade", "medicineDelivery.medicineAmount"),
    dateColumn("lastDelivery", "controlPanelGl.previousDeliveryDate"),
  ];

  return (
    <>        
      <div className="col-xl-12 col-lg-12 col-md-12 col-12 mt-2 mb-5">
        <Table
          className="border-dialog-card mt-2 mb-2"
          data={reportData}
          columns={columns}
          options={defaultOptions()}
        />
      </div>
    </>
  );
};

export default PrescripctionsReport;
